import styled from "styled-components";

export const TestimonialWrapper = styled.div`
  padding: 50px 0px;
  text-align: center;
  @media (max-width: 992px) {
    padding: 50px 20px;
  }
`;

export const TestimonialImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  margin: 0 auto;
  border: 3px solid ${(p) => p.btncolor || "#e8341c"};
  background: #f0f0f0;
`;

export const TestimonialTitle = styled.h4`
  font-size: 22px;
  margin: 0;
  font-weight: 600;
  padding-top: 15px;
  color: ${(p) => p.headercolor || "inherit"};
  text-transform: none;
`;

export const PersonDetail = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  padding-top: 20px;
  color: ${(p) => p.btncolor || "inherit"};
  text-transform: none;
`;

export const TestimonialDescription = styled.p`
  color: #716c80;
  margin: 0;
  font-size: 14px;
  line-height: 2;
  padding-bottom: 40px;
  padding-top: 10px;
`;

export const BackButton = styled.button`
  display: inline-block;
  padding: 10px 28px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-transform: none;
  background: ${(p) => p.btnbgcolor || "#e8341c"};
  color: ${(p) => p.btntextcolor || "#ffffff"};
  transition: background 0.3s ease;
  margin-top: 10px;

  &:hover {
    background: ${(p) => p.btnbghvcolor || "#c62a14"};
  }
`;
